// Composant Footer - Affiche les liens de navigation et le copyright

import React from "react";
import { NavLink } from "react-router-dom";
import { useLanguage } from "../utils/LanguageContext";

const textContent = {
  fr: {
    about: "À propos",
    contact: "Contact"
  },
  de: {
    about: "Über uns",
    contact: "Kontakt"
  }
};

export default function Footer() {
    const { language } = useLanguage();
    const t = textContent[language];

    return (
      <footer class="bg-white shadow dark:bg-gray-900 ">
        <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
          <div class="sm:flex sm:items-center sm:justify-between">
            <ul class="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
              <li class="mr-4 hover:underline md:mr-6">
                <NavLink to="/about">{t.about}</NavLink>
              </li>
              <li class="hover:underline">
                <NavLink to="/contact">{t.contact}</NavLink>
              </li>
            </ul>
          </div>
          <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
          <span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400">
            © {new Date().getFullYear()}{" "}
            <a href="/" class="hover:underline">
              SmoFR
            </a>
          </span>
        </div>
      </footer>
    );
  }

